import React, { useEffect, useState } from "react";
import { CardText, Row, Col } from "reactstrap";
import "assets/scss/website/app.scss";
import "react-rangeslider/lib/index.css";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import Nouislider from "nouislider-react";
import "nouislider/distribute/nouislider.css";
import "react-multi-carousel/lib/styles.css";
import { useSelector, useDispatch } from "react-redux";
import { appendFilters, resetFilters } from "store/filter/actions";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import RoomFilter from "./RoomFilter";
import { AvField } from "availity-reactstrap-validation";

const TopFilter = ({
	id,
	setLoading,
	loading,
	topFilterError,
	setTopFilterError,
}) => {
	const filterData = useSelector((state) => state.filter);
	const AuthData = useSelector((state) => state.Auth);
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const [bedRomms, setBedRomms] = useState([]);
	const [bathRomms, setBathRomms] = useState([]);
	const [floors, setFloors] = useState([]);

	const showLoading = () => setLoading(true);

	useEffect(() => {
		setBedRomms(filterData?.bedrooms);
		setBathRomms(filterData?.bathrooms);
		setFloors(filterData?.floor);
	}, [id]);

	const onSlide = (...rest) => {
		dispatch(appendFilters({ budget: rest[0], page: 1 }));
		showLoading();
	};

	const onSlideSize = (...rest) => {
		dispatch(appendFilters({ size: rest[2], page: 1 }));
		showLoading();
	};

	return (
		<div className="py-3 position-relative compound-top-filter">
			{loading ? (
				<div
					style={{
						opacity: ".6",
						zIndex: 300,
						position: "absolute",
						width: "100%",
						height: "100%",
						top: 0,
						left: 0,
					}}></div>
			) : null}
			<AvForm>
				<div
					className={`d-flex ${
						topFilterError ? "justify-content-between" : "flex-row-reverse"
					}`}>
					{/* {topFilterError && (
						<CardText tag="h6" className={`fw-bold pt-3 error`}>
							Choose a filter, then click on Interactive Mode
						</CardText>
					)} */}
					<button
						className="btn shadow-none font-size-14 text-primary px-0 "
						type="button"
						onClick={() => {
							dispatch(resetFilters());
							showLoading();
						}}>
						{t("reset all")}
					</button>
				</div>
				<div className="pt-3 ">
					<CardText
						tag="h6"
						className={`fw-bold font-size-18 text-primary ${
							topFilterError ? "error" : ""
						}`}>
						{t("property type")}
					</CardText>
					<div
						className="d-grid mt-3"
						style={{ gridTemplateColumns: "auto auto auto auto auto" }}>
						{filterData.unitTypeOptions.map((type, index) => {
							return (
								<label className="select" key={index}>
									<input
										type="checkbox"
										// className="btn-check"
										name="UnitType"
										id={`btncheckType${index}`}
										autoComplete="off"
										checked={filterData.unitType.some(
											(item) => item?.name?.en === type?.name?.en
										)}
										onChange={() => {
											const isExist = filterData.unitType.some(
												(item) => item?.name?.en === type?.name?.en
											);
											if (!isExist) {
												setTopFilterError(false);
												dispatch(
													appendFilters({
														unitType: [...filterData.unitType, type],
														page: 1,
													})
												);
												showLoading();
											} else {
												const updatedData = filterData.unitType.filter(
													(item) => item?.name?.en !== type?.name?.en
												);
												dispatch(
													appendFilters({
														unitType: [...updatedData],
														page: 1,
													})
												);
												showLoading();
											}
										}}
									/>
									{type?.name?.en}
								</label>
							);
						})}
					</div>
				</div>
				<Row>
					<Col md={12} className="mt-4">
						<Col md={12}>
							<CardText
								tag="h6"
								className={`fw-bold font-size-18 text-primary ${
									topFilterError ? "error" : ""
								}`}>
								{t("finishing")}
							</CardText>
							<div
								data-toggle="buttons"
								className="d-grid mt-3"
								style={{ gridTemplateColumns: "auto auto auto auto auto" }}>
								{filterData.finishingOptions.map((type, index) => {
									return (
										<label className="select" key={index + 1}>
											<input
												type="checkbox"
												// className="btn-check"
												name="typeFinish"
												id={`typeFinish${index + 1}`}
												autoComplete="off"
												checked={filterData.finishingType.some(
													(item) => item?.name?.en === type?.name?.en
												)}
												onChange={() => {
													const isExist = filterData.finishingType.some(
														(item) => item?.name?.en === type?.name?.en
													);
													if (!isExist) {
														setTopFilterError(false);
														dispatch(
															appendFilters({
																finishingType: [
																	...filterData.finishingType,
																	type,
																],
																page: 1,
															})
														);
														showLoading();
													} else {
														const updatedData = filterData.finishingType.filter(
															(item) => item?.name?.en !== type?.name?.en
														);
														dispatch(
															appendFilters({
																finishingType: [...updatedData],
																page: 1,
															})
														);
														showLoading();
													}
												}}
											/>
											{type?.name?.en}
										</label>
									);
								})}
							</div>
						</Col>
						{!!filterData?.CategortiesOptions?.length && (
							<Col md={12} className="mt-3">
								<CardText
									tag="h6"
									className={`fw-bold font-size-18 text-primary ${
										topFilterError ? "error" : ""
									}`}>
									{t("Categories")}
								</CardText>
								<div
									className="d-grid mt-3"
									style={{ gridTemplateColumns: "auto auto auto auto auto" }}>
									{filterData?.CategortiesOptions?.map((type, index) => {
										return (
											<label className="select" key={index}>
												<input
													type="checkbox"
													className="btn-check"
													name="typeCatogory"
													id={`typeCatogory${index}`}
													autoComplete="off"
													onChange={() => {
														const isExist = filterData.categories_ids.some(
															(item) => item?.name?.en === type?.name?.en
														);
														if (!isExist) {
															setTopFilterError(false);
															dispatch(
																appendFilters({
																	categories_ids: [
																		...filterData.categories_ids,
																		type,
																	],
																	page: 1,
																})
															);
															showLoading();
														} else {
															const updatedData =
																filterData.categories_ids.filter(
																	(item) => item?.name?.en !== type?.name?.en
																);
															dispatch(
																appendFilters({
																	categories_ids: [...updatedData],
																	page: 1,
																})
															);
															showLoading();
														}
													}}
													checked={filterData.categories_ids.some(
														(item) => item?.name?.en === type?.name?.en
													)}
												/>
												{type?.name?.en}
											</label>
										);
									})}
								</div>
							</Col>
						)}
					</Col>
					{!!filterData.size && (
						<Col md={4} className="price-square-input">
							<label className="fw-bold">
								{t("Square Meter")} ({t("M2")})
							</label>
							<Row>
								<Col md={6}>
									<AvField
										name="square"
										type="number"
										min="1"
										placeholder={t("Min")}
										className="fotm-control btnHeight mb-2"
										value={Math.round(filterData.size[0])}
										onChange={(e) => {
											dispatch(
												appendFilters({
													size: [Number(e.target.value), filterData.size[1]],
												})
											);
										}}
									/>
								</Col>
								<Col md={6}>
									<AvField
										name="square"
										type="number"
										min="1"
										placeholder={t("Max")}
										className="fotm-control btnHeight mb-2"
										value={filterData.size[1]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													size: [filterData.size[0], Number(e.target.value)],
												})
											);
										}}
									/>
								</Col>
							</Row>
						</Col>
					)}
					{!!filterData.budget && (
						<Col md={4} className="price-square-input">
							<label className="fw-bold">{t("Price Range")}</label>
							<Row>
								<Col md={6}>
									<AvField
										name="budget"
										type="number"
										min="1"
										placeholder={t("Min")}
										className="fotm-control btnHeight mb-2"
										value={filterData.budget[0]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													budget: [
														Number(e.target.value),
														filterData.budget[1],
													],
												})
											);
										}}
									/>
								</Col>
								<Col md={6}>
									<AvField
										name="budget"
										type="number"
										min="1"
										placeholder={t("Max")}
										className="fotm-control btnHeight mb-2"
										value={filterData.budget[1]}
										onChange={(e) => {
											dispatch(
												appendFilters({
													budget: [
														filterData.budget[0],
														Number(e.target.value),
													],
												})
											);
										}}
									/>
								</Col>
							</Row>
						</Col>
					)}

					<Col md={4}></Col>
					<Col md={4}>
						<label className="fw-bold mt-4 text-primary">{t("Floor")}</label>
						<div className="d-block btn-group-toggle " data-toggle="buttons">
							<RoomFilter
								setTopFilterError={setTopFilterError}
								roomsType={"floorRange"}
								value={"floor"}
								showLoading={showLoading}
							/>
						</div>
					</Col>
					<Col md={4}>
						<label className="fw-bold mt-4 text-primary">{t("Bedrooms")}</label>
						<div className="d-block btn-group-toggle" data-toggle="buttons">
							<RoomFilter
								setTopFilterError={setTopFilterError}
								roomsType={"bedroomsRange"}
								value={"bedrooms"}
								showLoading={showLoading}
							/>
						</div>
					</Col>
					<Col md={4}>
						<label className="fw-bold mt-4 text-primary">
							{t("Bathrooms")}
						</label>
						<div className="d-block btn-group-toggle" data-toggle="buttons">
							<RoomFilter
								setTopFilterError={setTopFilterError}
								roomsType={"bathroomsRange"}
								value={"bathrooms"}
								showLoading={showLoading}
							/>
						</div>
					</Col>
				</Row>
			</AvForm>
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default TopFilter;
